export const MIN_CHANNEL_NUMBER = 1;

export const MAX_CHANNEL_NUMBER = 9999;
